import Decline from 'features/myVaro/screens/PersonalDetails/ChangePhoneNumber/Decline/Decline';
import React from 'react';

export default function Page() {
  return <Decline />;
}
